import React, { useEffect } from 'react';

import { TemplatesProvider } from 'Templates';

import {
  BreadcrumbProvider,
  useScreenBreadcrumbsParams,
  createScreenRoute,
  Route,
  useLocation,
} from '@gogame/screens';
import { Sentry } from '@gogame/components';

import { useGalleryPermissions } from 'scenes/Gallery/GalleryPage/hooks';
import {
  conceptPreviewLink,
  conceptFamilyPreviewLink,
  galleryLink,
  gallerySearchParams,
} from 'scenes/Gallery/GalleryPage/navigation';

import { permission } from './constants';
import ConceptFamiliesPreviewScreen from './screens/ConceptFamiliesPreviewScreen';
import ConceptPreviewScreen from './screens/ConceptPreviewScreen';
import GalleryScreen from './screens/GalleryScreen';

const id = 35;

const Gallery = () => {
  const [, setParams] = useScreenBreadcrumbsParams();
  const { search } = useLocation();
  const { isAllowConceptFamilies } = useGalleryPermissions();
  useEffect(() => {
    const { filters, searchQuery } = gallerySearchParams.parse(search);

    setParams({ filters, searchQuery });
  }, [search]);

  return (
    <Sentry.Routes>
      <Route
        path={`${conceptPreviewLink.path}/*`}
        element={
          <BreadcrumbProvider title={'loading...'}>
            <ConceptPreviewScreen />
          </BreadcrumbProvider>
        }
      />
      {isAllowConceptFamilies && (
        <Route
          path={`${conceptFamilyPreviewLink.path}/*`}
          element={
            <BreadcrumbProvider title={'loading...'}>
              <ConceptFamiliesPreviewScreen />
            </BreadcrumbProvider>
          }
        />
      )}

      <Route path={'/*'} element={<GalleryScreen />} />
    </Sentry.Routes>
  );
};
export default createScreenRoute({
  id: id,
  title: 'Gallery',
  link: galleryLink,
  screen: (
    <TemplatesProvider serverPageId={id}>
      <Gallery />
    </TemplatesProvider>
  ),
  permission: permission,
  knowledgeBaseUrl:
    'https://go-game.zendesk.com/hc/en-us/sections/5033803504412-Gallery',
});
